export const BASIC = "Basic"
export const PREMIUM = "Premium"
export const ELITE = "Elite"
